export const formatTrimZeroes = (str) => {
  return (str || '').replace(/^0+/g, '');
};
